<!-- 索赔 -->
<template>
  <h-list-page class="qm-checking-container">
    <h-card :title="h_i18n('5c03478a15de84c5c7b12513c015835e')" width="100%" :is-left="0" is-search footer @change-method="changeMethod">
      <h-area title-width="90px" :all-span="7">
        <h-search :title="h_i18n('130de92a66ef6e0eb9fde34a87492a1f')">
          <h-input v-model.trim="searchData.claimCode" :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')" clearable @clear="handleChange(searchData.claimCode,'claimCode')"></h-input>
        </h-search>
        <h-search :title="h_i18n('03490f3868798323211aa633194df2c1')">
          <h-select v-model="searchData.sybName" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" filterable clearable @clear="handleChange(searchData.sybName,'sybName')">
            <h-option v-for="item in sybList" :key="item" :label="item" :value="item"></h-option>
          </h-select>
        </h-search>
        <h-search :title="h_i18n('ec46bb5e826a9e2d3dd26aad97946925')">
          <h-select v-model="searchData.claimType" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" filterable clearable @clear="handleChange(searchData.claimType,'claimType')">
            <h-option v-for="item in questionNode" :key="item.valueId" :label="item.valueName" :value="item.valueId"></h-option>
          </h-select>
        </h-search>
        <!-- 状态  -->
         <!-- <h-search :title="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')">
          <h-select v-model="searchData.claimStatus" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" filterable clearable @clear="handleChange(searchData.claimStatus,'claimStatus')">
            <h-option v-for="item in claimStatusList" :key="item.value" :label="item.label" :value="item.value"></h-option>
          </h-select>
        </h-search> -->
        <!-- 交互结果 -->
         <h-search :title="h_i18n('91d5e5a8236e72af007dcfbf1e799b56')">
          <h-select v-model="searchData.jhState" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" filterable clearable @clear="handleChange(searchData.jhState,'jhState')">
            <h-option v-for="item in jhStateList" :key="item.value" :label="item.label" :value="item.value"></h-option>
          </h-select>
        </h-search>
        <h-search :title="h_i18n('8f30e9f8678c24496921bebae6ca2ac6')">
          <h-select v-model="searchData.year" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" filterable clearable @clear="handleChange(searchData.year,'year')">
            <h-option v-for="item in yearArray" :key="item.valueId" :label="item.valueName" :value="item.valueId"></h-option>
          </h-select>
        </h-search>
        <h-search :title="h_i18n('8190915888889ed18be44ea0351d0448')">
          <h-select v-model="searchData.month" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" filterable clearable @clear="handleChange(searchData.month,'month')">
            <h-option v-for="item in mounthArray" :key="item.valueId" :label="item.valueName" :value="item.valueId"></h-option>
          </h-select>
        </h-search>
        <!-- 扣款月份 -->
        <h-search :title="h_i18n('f9707cf0d21826afb0d2d4a088a5ba85')">
          <h-date-picker v-model="searchData.deductions" type="month" :placeholder="h_i18n('7f83cefc6354ed7819de9ca50d15c5ed')"
           @change="monthChange" value-format="yyyy-MM"></h-date-picker>
        </h-search>
        <!-- 生成时间 -->
        <h-search :title="h_i18n('b683c82e9310494611d6a8c1db41bd34')">
          <h-date-picker @change="TimeChange(dateTwo, {start:'beginDateTwo',end:'endDateTwo'})" 
            v-model="dateTwo"
            type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" 
            :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble" />
        </h-search>
        <template #operate>
          <h-button type="primary" :loading="tableLoading" @click="searchDataFun">
            <template #icon><search/></template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>
      </h-area>
    </h-card>
    <h-table-card :title="h_i18n('5c03478a15de84c5c7b12513c015835e')">
      <template #buttonGroup>
        <h-button-group>
          <template v-for="item in btnListOfSqm" :key="item.code">
            <template v-if="item.code == 'mkhl_zlsp_sp_update'">
              <h-button type="primary" @click="handleMerge">
                <template #icon><i class="iconfont icon-xinzeng"></i></template>{{ h_i18n('a872323deec0f6d8541fb8f448c375ca') }}</h-button>
            </template>
            <template v-if="item.code == 'mkhl_zlsp_sp_export'">
              <h-button type="primary" @click="handleExport">
                <template #icon><i class="iconfont icon-daochu"></i></template>{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}</h-button>
            </template>
          </template>
          <!-- <div style="margin-left: 10px;">
            <h-button type="primary" @click="handleVersion">
            切换旧版
            </h-button>
            <span style="font-size: 12px;color: red;position: relative;top: 5px;">
              备注：索赔新版试运行，老版本预计3月15号下线；新版使用过程中若有问题请及时反馈，紧急业务可优先切换旧版处理。
            </span>
          </div> -->
        </h-button-group>
      </template>
      <el-table ref="multipleTable" :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" size="small" row-key="claimCode" @selection-change="handleSelectionChange" border
                :data="tableData" height="660" style="width: 100%;min-height: 660px" v-loading="tableLoading">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="40">
          <template v-slot="scope">
            {{ (scope.$index+1)+(pageNo-1)*10 }}
          </template>
        </el-table-column>
        <!-- 年 -->
        <el-table-column prop="year" :label="h_i18n('465260fe80b0c3338d06194bb7a94446')" width="60"></el-table-column>
        <!-- 月 -->
        <el-table-column prop="month" :label="h_i18n('e42b99d59954ce6437e66f416850425a')" width="40"></el-table-column>
        <!-- 交互结果 -->
        <el-table-column prop="jhState" :label="h_i18n('91d5e5a8236e72af007dcfbf1e799b56')" width="120">
          <template #default="{row}">
            <el-tag size="small" v-if="row.jhState === 1082" type="success">{{ jhStateList.find(item => item.value === row.jhState)?.label  }}</el-tag>
            <el-tag size="small" v-else-if="row.jhState === 1800" type="warning">{{ jhStateList.find(item => item.value === row.jhState)?.label  }}</el-tag>
            <el-tag size="small" v-else-if="row.jhState === 1801" type="process">{{ jhStateList.find(item => item.value === row.jhState)?.label  }}</el-tag>
            <el-tag size="small" v-else-if="row.jhState === 1804" type="danger">{{ jhStateList.find(item => item.value === row.jhState)?.label  }}</el-tag>
            <el-tag size="small" v-else-if="row.jhState === 1803" type="success">{{ jhStateList.find(item => item.value === row.jhState)?.label  }}</el-tag>
            <el-tag size="small" v-else-if="row.jhState" type="default">{{ jhStateList.find(item => item.value === row.jhState)?.label  }}</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
         <!-- 状态 -->
        <!-- <el-table-column prop="claimStatus" :label="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')">
          <template #default="{row}">
            <el-tag size="small" v-if="row.claimStatus === 1359" type="warning">{{ claimStatusList.find(item => item.value === row.claimStatus)?.label  }}</el-tag>
            <el-tag size="small" v-else-if="row.claimStatus" type="success">{{ claimStatusList.find(item => item.value === row.claimStatus)?.label  }}</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column> -->
        <!-- 工厂小微 -->
        <el-table-column prop="sybName" :label="h_i18n('03490f3868798323211aa633194df2c1')"></el-table-column>
        <el-table-column prop="supplyCode" :label="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')"></el-table-column>
        <el-table-column prop="supplyName" :label="h_i18n('f5c96a23588a9d9a9e689d643096b193')" width="180"></el-table-column>
        <el-table-column prop="claimMoney" :label="h_i18n('4cf24aba16658a855f07d171731226f6')"></el-table-column>
        <el-table-column prop="caDate" :label="h_i18n('95136f280d955a54664140fea62936a8')" width="100"></el-table-column>
        <el-table-column prop="claimCode" :label="h_i18n('130de92a66ef6e0eb9fde34a87492a1f')" width="170"></el-table-column>
        <el-table-column prop="claimTypeName" :label="h_i18n('ec46bb5e826a9e2d3dd26aad97946925')" width="120"></el-table-column>
        <el-table-column prop="deductionsDate" :label="h_i18n('628d9b1d0636d63e358f2f6e3bcde714')" width="100"></el-table-column>
        <el-table-column prop="isRepeatName" :label="h_i18n('2f0ee0799c127d34daabcaaf367cbf8b')" width="80"></el-table-column>
        <!-- 生成时间 -->
        <el-table-column prop="isrtDate" :label="h_i18n('b683c82e9310494611d6a8c1db41bd34')" width="160">
          <template #default="{row}">
            <span v-if="row.isrtDate">{{ time(row.isrtDate, 6) }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        
        <el-table-column :label="h_i18n('2b6bc0f293f5ca01b006206c2535ccbc')">
          <template v-slot="scope">
            <h-button type="primary" @click="handleDetail(scope.row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</h-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @current-change="handleCurrentChange" :page-size="10"
                     v-model:currentPage="pageNo" layout="total, prev, pager, next,jumper" :total="total">
      </el-pagination>
    </h-table-card>
  </h-list-page>
</template>

<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { mounthArray, questionNode, getYearsArray } from './index.js'
// import SmartCA_OneCert_lib from '../../../../public/static/SmartCA_PKI_Lib.js'

export default {
  data(){
    return{
      dateTwo: '',
      searchData:{},
      tableLoading: false,
      tableData:[],
      pageNo:1,
      total:0,
      mounthArray,
      yearArray:[],
      sybList:[],
      questionNode,
      checkIndexArr:[],
      signatureObj:{},
      signNewInfo:{}, // signNew 所需信息
      itemIndex:0, // 选中数据个数 在fn mergeSign 中赋值 调用 fn signMerge时传入
      dataItem:{}, // 临时数据data list单条
      data:[],
      failData:[], // 失败提示-批量
      beforeCAPdfUrl:'', // 签章所需PDF数据
      beforeCAPdfName:'',
      alreadyCA:[],// 已经签章的数组
      successData:[],
      btnCodeList:[
      "mkhl_zlsp_sp_update","mkhl_zlsp_sp_export"
      ],
      btnListOfSqm:[],
      keepalivestatus: 0,
      claimStatusList:[],
      jhStateList:[],
    }
  },
  methods:{
    h_i18n,
    // 时间范围选择
    TimeChange (date, {start,end}) {
      if (date) {
        this.searchData[start] = this.time(date[0])+' 00:00:00';
        this.searchData[end] = this.time(date[1])+' 23:59:59';
      } else {
        this.searchData[start] = undefined;
        this.searchData[end] = undefined;
      }
    },
    // 查询状态表
    getBaseValues(){
      this.$http({
        method: "post",
        url: "/base/basicData/listBaseValuesByIds",
        data: [67,85],
      }).then((res) => {
        if (res.data.code === "200") {
          res.data.data.forEach(item=>{
            // if(item.valueTypeId == 67){ // 状态
            //   this.claimStatusList.push({value:item.valueId,label:item.valueName})
            // }
            if(item.valueTypeId == 85){ // 交互结果
              this.jhStateList.push({value:item.valueId,label:item.valueName})
            }
          })
        } else {
        }
      }).catch((err) => {
      });
    },
    handleChange(val,key){
      if(val==''||val==undefined||val==null){
        this.searchData[key] = undefined
        this.$router.replace({query:{
            name: this.$route.query.name,
            nickName: this.$route.query.nickName,
            dataFrom: this.$route.query.dataFrom,
            group: this.$route.query.group,
            ...this.searchData
          }
        })
      }
    },
    monthChange(val){
      console.log('val',val)
      if(val){
        let month = new Date(val).getMonth()+1
        if((new Date(val).getMonth()+1)<10){
          month = `0${month}`
        }
        this.searchData.deductions = `${new Date(val).getFullYear()}-${month}`
      }else{
        this.handleChange(val,'deductions')
      }
    },
    changeMethod(){
      this.postThisPageHeight()
    },
    searchDataFun(){
      if(this.searchData.month&&(this.searchData.year==''||this.searchData.year==null||this.searchData.year==undefined)){
        this.info(h_i18n('82a673eb8e5d6ade54eb3250a3d93f5c'))
        return false
      }
      this.tableLoading = true
      const params = Object.assign({},{...this.searchData})
      this.searchData.year ? params.year = Number(this.searchData.year) : ''
      this.searchData.month ?  params.month = Number(this.searchData.month) : ''

      this.$http({
        url: '/base/qualityClaim/selectPage',
        method: 'post',
        data: {
          ...params,
          pageNo: this.pageNo,
          pageSize: 10,
        }
      }).then(res => {
        this.tableLoading = false
        if(res.status == 200){
          this.tableData = res.data.data.records || []
          this.total = res.data.data.total
        }
      }).catch(err => {
        this.tableLoading = false
        this.error(h_i18n('0d66ed02d74d0bd89431d6d59533ffb3'))
        console.log(err)
      })
    },
    handleSelectionChange(val){
      this.checkIndexArr = [...val]
    },
    handleCurrentChange(val){
      this.pageNo = val
      this.searchDataFun()
    },
    // 获取工厂小微
    getSybArray(){
      this.$http({
        method: 'get',
        url: '/base/qualityClaim/getSybList',
        headers: { 'content-type': 'application/json' },
        params: {
         supplyCode: this.$route.query.supplyCode||this.$route.query.supplycode
        }
      })
      .then((res) => {
        this.sybList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    // 跳转详情页面
    handleDetail(row){
      console.log('------------row',row,this.$route)
      const params = {}
      params.name = this.$route.query.name
      params.nickName = this.$route.query.nickName
      params.dataFrom = this.$route.query.dataFrom
      params.group = this.$route.query.group
      params.searchClaimCode = this.searchData.claimCode
      params.sybName = this.searchData.sybName
      params.claimType = this.searchData.claimType
      params.year = this.searchData.year
      params.month = this.searchData.month
      params.deductions = this.searchData.deductions
      params.pageNo = this.pageNo
      console.log('params========',params)
      this.$router.push({name:'claimantDetail',query:{claimCode:row.claimCode,supplyCode:this.$route.query.supplyCode||this.$route.query.supplycode,...params,roleCode:this.$route.query.roleCode}})
    },
    // 导出
    handleExport(){
      this.exportLoading = true;
      this.startLoading(h_i18n('e8e4b01cf7b657ae473fd5279ccdda25'));
      this.httpFile(
        {
          method: "post",
          url: "/base/qualityClaim/exportPage",
          data: {
            ...this.searchData,
            // pageNo: this.pageNo,
            // pageSize: this.pageSize,
            name: this.$route.query.name,
            nickName: this.$route.query.nickName
          },
        },
        h_i18n('c7cf0422dbd07f420d208c3268f522d9')
      ).then(res=>{
        this.exportLoading = false;
        this.closeLoading();
      }).catch(err=>{
        this.exportLoading = false;
        this.closeLoading()
      })
    },
    // 合并签章按钮
    handleMerge(){
      let roleCode = this.$route&&this.$route.query&&this.$route.query.roleCode?this.$route.query.roleCode:''

      if(roleCode != 'S009'){
        this.info(h_i18n('a0a8a703eca5700bcb7bb41b9bab290e'));
        return false
      }
      if(!this.$route.query.nickName||this.$route.query.nickName===''||this.$route.query.nickName===null||this.$route.query.nickName===undefined){
        this.info({message: `${h_i18n('4e225329570ec564d12e1f5a66ea73c6')}`, title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770')})
        return false
      }
      console.log('this.checkIndexArr',this.checkIndexArr)
      if(this.checkIndexArr&&this.checkIndexArr.length>0){
        let arr = []
        this.checkIndexArr.forEach(item=>{
          if(item.jhState == "1801" || item.jhState == "1802" ||item.jhState == "1803"){
            arr.push(item.claimCode)
          }
        })
        if(arr&&arr.length>0){
          this.info(arr.join(',')+h_i18n('3ec0a3258677dd8bcf209b2d7d99f9f8'))
          let tmpCheckArr = this.checkIndexArr.filter(item => {
            if(!arr.includes(item.claimCode)){
              this.$refs.multipleTable.toggleRowSelection(item,true)
              return item
            }else{
              this.$refs.multipleTable.toggleRowSelection(item,false)
            }
          })
          this.checkIndexArr = [...tmpCheckArr]
        }
      }
      this.successData = []
      this.failData = []
      if(sessionStorage.getItem("CATime") == null){
        console.log('1111',sessionStorage.getItem("CATime"))
        this.getCertPin()
      }else if(Date.now() - sessionStorage.getItem("CATime") > 1680000){
        console.log('22222',Date.now() - sessionStorage.getItem("CATime"))
        this.getCertPin()
      }else{
        console.log('333333')
        this.signNewInfo = JSON.parse(sessionStorage.getItem("signNewInfo"))
        if(this.checkIndexArr.length > 0){
          this.itemIndex = this.checkIndexArr.length
          console.log('444444', this.itemIndex)
          setTimeout(()=>{
            this.signMerge(this.itemIndex)
          })
        }else{
          this.info(h_i18n('5b08aa8e5d9f01eecab92d8b558dc92e'))
        }
      }
    },
    /**
    *function
    *批量签章 入口createPDF
    */
    signMerge(itemIndex){
      if(itemIndex <= 0){
        return
      }
      console.log('this.checkIndexArr',this.checkIndexArr)
      console.log('this.tableData',this.tableData)
      // TODO dataItem没有取到值
      this.dataItem = this.checkIndexArr[this.itemIndex-1]
      console.log('this.dataItem',this.dataItem)
      this.$http({
        url: `/base/claimConfirm/getClaimConfirmInfo?claimCode=${this.dataItem.claimCode}`,
        method: 'get'
      }).then(res => {
        this.signatureObj = res.data.data
        if(this.signatureObj.isView == 0){
          // 开始执行签章--从pdf开始
          this.createPDF(this.dataItem)
        }else{
          this.signNew(this.dataItem.claimCode) // 获取certPin后 半小时内 批量签章功能
        }

      }).catch(err => {
        this.closeLoading()
        this.mergeFail(err)
      })
    },
    // 生成未签章的pdf
    createPDF(){
      this.$http({
        url: '/base/qualityClaim/createPdf',
        method: 'get',
        params:{
          claimCode: this.dataItem.claimCode,
          name: this.$route.query.name||this.$route.query.nickName,
          person: this.$route.query.name||this.$route.query.nickName,
        }
      }).then(res => {
        if(res.data.code == 200){
          this.signNew() // 获取certPin后 半小时内 批量签章功能
        }else{
          this.mergeFail(res.data)
        }
        this.closeLoading()
      }).catch(err => {
        console.log(err)
        this.closeLoading()
        this.mergeFail(h_i18n('d05d459be8e7deaeee2927a346b435ae'))
      })
    },

    /**
    *function merge失败调用的方法
    */
    mergeFail(errStr){
      console.log('errStr',errStr)
      console.log('this.dataItem.claimCode',this.dataItem.claimCode)
      this.failData.push(this.dataItem.claimCode+"-"+(errStr.msg||errStr.message))
        this.itemIndex --
        if(this.itemIndex == 0){
          setTimeout(()=>{
            this.info(this.failData.join(','))
          },800)
        }else{
          setTimeout(()=>{
            this.signMerge(this.itemIndex)
          })
        }
    },
    /**
    *function 调用ca证书授权半小时  $SmartCAIE()
    */
    getCertPin(){
      let that = this
      var Cert = '';
      var finger = '';
      var subjectContains = '';
      var issuerContains = '';
      var keyUsage = 32;  //32签名证书，16加密证书，32|16 枚举所有
      var cryptoInterface = 1; //1：只枚举SM2证书； 2：只枚举RSA证书；3：枚举所有证书
      var defaultSelect = 1; //1:默认选择唯一的那张证书， 0：不设置
      var noCertErr = 0; //1:没有证书的时候，不再弹出空的证书选择列表， 0：不设置
      let p = new Promise((resolve,reject)=>{
        SmartCA_OneCert_lib.getCertInfoAndVerifyPIN(Cert, finger, subjectContains, issuerContains, keyUsage, cryptoInterface, defaultSelect, noCertErr, function (res) {
          resolve(res)
        },err=>{

          console.log('err',err)
          reject(err)
        })
      })
      //查询证书信息
      p.then(res => {
        try {
          this.$http({
            method: 'GET',
            url: `/base/batchPlanApp/frontLogs?frontLog=${JSON.stringify(res)}` + "&userId=" + this.checkIndexArr[0].claimCode,
          })
        } catch (e) {
          console.log("掉后端打印失败", e)
        }
        console.log('查询证书信息',res)
        // 校验start TODO看看subject是啥
        var subject = res.Subject
        if (!subject) {
          console.log('证书Subject项获取失败，请联系管理员!')
          that.info(h_i18n('26430ba03bcfc728f4dd4f42218ac257'))
          return
        }
        var subjectWithoutBlankSpace =subject.split(" ").join("")
        if (!subjectWithoutBlankSpace) {
          console.log('证书Subject项获取失败，请联系管理员')
          that.info(h_i18n('26430ba03bcfc728f4dd4f42218ac257'))
          return
        }
        var subjectObj = {}
        let pairs = subjectWithoutBlankSpace.split(",");
        for(var i=0;i<pairs.length;i++){
          var arr = pairs[i].split('=');
          subjectObj[arr[0]] = arr[1];
        }
        console.log('&&&&&&&&&&subjectObj',subjectObj)
        if (process.env.NODE_ENV == 'production'){
          if (!subjectObj.O) {
            that.info(h_i18n('235efacde3fb0e7a39d8a6fe508f3fe6'))
            return
          }
          if (that.$route.query.supplyCode != subjectObj.O) {
            that.info(h_i18n('1f7eff2b41184292c9aa92fde6d86f6c')+that.$route.query.supplyCode + h_i18n('68e0f86b8b51272fa339a45d2d187870')+subjectObj.O);
            that.info(h_i18n('ca5f860b0d53b16659281f068502ac17'))
            return
          }
        }
        // 校验end
        // 设置signNew所需数据
        that.signNewInfo.res = res
        that.signNewInfo.cryptoInterface = cryptoInterface
        that.signNewInfo.defaultSelect = defaultSelect
        that.signNewInfo.noCertErr = noCertErr
        // 设置 sessionStorage
        sessionStorage.setItem("CATime",Date.now())
        sessionStorage.setItem("signNewInfo" , JSON.stringify(that.signNewInfo))
        // 再进行合并签章
        that.handleMerge()
      }).catch(err => {
        var txt = 'code=' + err.ErrorCode + ',msg=' + err.ErrorMsg;
        that.info(`${txt}`);
      })
    },
    // 获取uuid 证书时需要
    uuid() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      return uuid;
    },
    /**
    *functino
    *获取certPin后 半小时内 批量签章功能
    */
    signNew(claimCode){
      let that = this
      that.startLoading(h_i18n('78e53631ae3ca999c22a3983fc32c2a8'))
      var bizCode = that.uuid();
      console.log('this.signNewInfo',that.signNewInfo);
      that.$http({
        url: '/base/qualityClaim/registerPdf',
        method: 'post',
        data:{
          'fileUuid': that.signatureObj.fileUUID,
          'clientcert': encodeURI(that.signNewInfo.res.Content),
          'bizCode': bizCode,
          'claimCode': claimCode
        }
      }).then(tmp => {
        console.log('##########',tmp)
        if (tmp.data.code == 200) {
          // 调用UK进行签名
          var Alg = 'sm3';
          var pwd = '';
          bizCode = tmp.data.bizCode
          let p1 = new Promise((resolve,reject)=>{
            console.log(tmp.data.result, that.signNewInfo.res.Content, that.signNewInfo.res.ThumbprintSHA1, Alg, pwd, that.signNewInfo.cryptoInterface, that.signNewInfo.defaultSelect, that.signNewInfo.noCertErr)
            SmartCA_OneCert_lib.pkcs1Digest(tmp.data.result, that.signNewInfo.res.Content, that.signNewInfo.res.ThumbprintSHA1, Alg, pwd, that.signNewInfo.cryptoInterface, that.signNewInfo.defaultSelect, that.signNewInfo.noCertErr, function (res) {
              console.log('pkcs1Digestpkcs1Digestpkcs1Digest',res)
              resolve(res)
              },err => {
                reject(err)
              })
            })

          p1.then(res => {
            try {
              this.$http({
                method: 'GET',
                url: `/base/batchPlanApp/frontLogs?frontLog=${JSON.stringify(res)}` + "&userId=" + this.checkIndexArr[0].claimCode+"2",
              })
            } catch (e) {
              console.log("掉后端打印失败", e)
            }
             console.info(h_i18n('d17e8449812f65c7a71107612bb48d82') + res.signData);
          // 调用签章接口
          // var tmp2 = that.pdf_sign(res.signData, bizCode)
          // if (!tmp2 || !tmp2.url) {
          //   that.mergeFail('无签章后文件地址，请联系管理员或提报ESP!')
          //   return false
          // }
            that.$http({
              url: '/base/qualityClaim/signaturePdf',
              method: 'post',
              data:{
                'signvalue': encodeURI(res.signData),
                'bizCode': bizCode,
                'beforeCAPdfName': that.beforeCAPdfName,
                'claimCode': that.dataItem.claimCode,
                'trueName': that.$route.query.nickName
              }
            }).then(res => {
              if (res.data.code == 200) {
                // 新增--成功后继续调用signMerge
                that.successData.push(that.dataItem.claimCode)
                that.itemIndex --
                if(that.itemIndex == 0){
                  setTimeout(()=>{
                    that.info(that.successData.join(',') + h_i18n('c759f53b640117aacea82228e3863e7c'))
                    setTimeout(()=>{
                      that.searchDataFun()
                    },100)
                  },800)
                }else{
                  setTimeout(()=>{
                    that.signMerge(that.itemIndex)
                  })
                }
              } else {
                // 新增--失败后继续调用signMerge
                that.mergeFail(res.data)
              }
            })
            this.closeLoading()
          }).catch(err=> {
            this.closeLoading()
            var txt = 'code=' + err.ErrorCode + ',msg=' + err.ErrorMsg;
            that.mergeFail(txt)
          })
        }else{
          this.closeLoading()
          that.mergeFail(tmp.data)
        }
      }).catch(err => {
        this.closeLoading()
        that.mergeFail(h_i18n('65804d0a9151694369ef103151ae81e0') + err.status)
      })
    },
    // 获取签章信息
    getInfo(dataItem){
      let claimCode = dataItem.claimCode
      this.$http({
        url: `/base/claimConfirm/getClaimConfirmInfo?claimCode=${claimCode}`,
        method: 'get'
      }).then(res => {
        this.signatureObj = res.data.data
        if(this.signatureObj){
          this.signNew(claimCode)
        }
        // if(res.data.data.isView=="1"){
        //   this.beforeCAPdfUrl = "/downLoadFileNew?type=1&fileUUID=" + res.data.data.fileuuid
        //   this.beforeCAPdfName = claimCode +".pdf"
        // }
        // if(res.data.data.isConfirm=="1"){
        //   this.beforeCAPdfUrl = "/downLoadFileNew?type=2&fileUUID=" + res.data.data.fileuuidConfirm
        //   this.beforeCAPdfName = claimCode +".pdf"
        // }
      }).catch(err => {
        this.warning({ message: err ? err : h_i18n('8e66e95910ab41cf44496adb1c40277f'), title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770') });
      })
    },
    handleVersion(){
      const vCode = this.$route.query.supplyCode

      if (process.env.NODE_ENV != 'production') {
        window.open("http://sqm-test.qd-huangdao-test.haier.net/claimant/claimant_supplier?supplyCode="+ vCode)
      }else{
        window.open("https://sqm.haier.net/claimant/claimant_supplier?supplyCode="+ vCode)
      }

    }
  },
  mounted(){
    if (this.$route.query) {
      this.searchData.name = this.$route.query.name
      this.searchData.nickName = this.$route.query.nickName
      this.searchData.supplyCode = this.$route.query.supplyCode||this.$route.query.supplycode
      this.pageNo = this.$route.query.pageNo||1

      this.$route.query.claimCode ? this.searchData.claimCode = this.$route.query.claimCode: ''
      this.$route.query.sybName ? this.searchData.sybName = this.$route.query.sybName : ''
      this.$route.query.claimType ? this.searchData.claimType = this.$route.query.claimType : ''
      this.$route.query.year ? this.searchData.year = this.$route.query.year : ''
      this.$route.query.month ? this.searchData.month = this.$route.query.month : ''
      this.$route.query.deductions ? this.searchData.deductions = new Date(this.$route.query.deductions) : ''
      console.log('this.searchData',this.searchData)
    }
    console.log('============',this.$route)
    if(this.$route.query.parentId && this.$route.query.parentId != 'null' && this.$route.query.parentId != 'undefined' && this.$route.query.parentId != ''){
      let p = this.getButtonFromSqm(this.$route.query.parentId,this.$route.query.roleCode)
      p.then(res=>{
        if(res.length > 0){
          this.btnListOfSqm = res
        }
      })
    }else{
      this.btnListOfSqm = [{code:"mkhl_zlsp_sp_update",name:h_i18n('a872323deec0f6d8541fb8f448c375ca')},{code:"mkhl_zlsp_sp_export",name:h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95')}]
    }
    this.yearArray = getYearsArray()
    this.getBaseValues()
    this.getSybArray()
    this.searchDataFun()
  },
  activated() {
    //console.log('keepalive-activated页面打开时触发');
    if (this.keepalivestatus == 0) {
      this.searchDataFun()
    } else {
      this.searchDataFun()
    }
  },
  deactivated() {
    this.keepalivestatus = this.keepalivestatus + 1;
    //console.log('keepalive-deactivated页面关闭时触发');
  },
  beforeMount(){
    // 使用oss加载jquery，解决haier内网访问cdn慢的问题
    let src = process.env.NODE_ENV === "test" ? "/sqm-workbench" : "/workBench"
    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://sqm.haier.net/readFile/basicInfo/juqery-min.js'
    let script2 = document.createElement('script')
    script2.type = 'module'
    script2.src = src+'/static/SmartCA_PKI_Lib.js'
    script.onload = (()=>{
      document.getElementsByTagName('head')[0].appendChild(script2)
    })
    script.onerror = (()=>{
      // 如果oss加载失败，使用cdn
      let script3 = document.createElement('script')
      script3.src = 'https://cdn.bootcdn.net/ajax/libs/jquery/1.5.1/jquery.min.js'
      document.getElementsByTagName('head')[0].appendChild(script3)
      let i = 0
      let timer = setInterval(() => {
        if(window.$){
          document.getElementsByTagName('head')[0].appendChild(script2)
          clearInterval(timer)
        }else{
          console.log('jquery未加载')
          i++
          if(i>50){
            // 5秒后停止，默认失败，刷新页面重试
            alert(h_i18n('8e44a23a0a482a36e7a17cb2f4d06499'))
            clearInterval(timer)
          }
        }
      }, 100);
    })
    document.getElementsByTagName('head')[0].appendChild(script)    
  }
}
</script>